import loadable from '@loadable/component';

export const UnpublishedInternshipPageLoadable = loadable(
  () => import('./UnpublishedInternshipPage'),
  { resolveComponent: (module) => module.UnpublishedInternshipPage },
);
